module.exports = __webpack_public_path__ + "fonts/TBCSailec-Regular.a33a8d16.woff2";